import React from "react";
import { Segment, Grid } from "semantic-ui-react";
import './NotFound.css';

const NotFound = () => (
  
  <Segment inverted vertical className="not-found">
    <Grid verticalAlign='middle' textAlign='center' className="not-found__grid mx-0">
      <Grid.Row>
        <Grid.Column>
          <div className=" itc-mdbold text-white not-found__title">404</div>
          <div className="not-found__desc text-white my-5">Sorry, that page doesn’t exist. <a href="/">Go home.</a></div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Segment>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/not-found/NotFound.js